import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import i18n from "./services/i18n";
import "@mdi/font/css/materialdesignicons.css";

import { inject } from "@vercel/analytics";

loadFonts();

const app = createApp(App);

app.use(router).use(store).use(vuetify).use(i18n);

inject();

app.mount("#app");

export { store, router };
